<template>
  <div>
    <div class="text-center warning--text pa-2 mb-2 fs-14px font-weight-medium">
      GIAO ĐI
    </div>
    <DeliveryProcessingStep1
      v-if="order.delivery_status == 2"
      :order="order"
      @confirmed="confirmed"
    />
    <DeliveryProcessingStep2 v-else :order="order" @finished="finished" />
  </div>
</template>

<script>
export default {
  name: "DeliveryProcessing",
  components: {
    DeliveryProcessingStep1: () =>
      import("@/components/rent/DeliveryProcessingStep1"),
    DeliveryProcessingStep2: () =>
      import("@/components/rent/DeliveryProcessingStep2"),
  },
  props: {
    order: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({}),
  computed: {},
  mounted() {},
  methods: {
    confirmed() {
      this.$emit("confirmed");
    },
    finished() {
      this.$emit("finished");
    },
  },
};
</script>
